import Logo from "@/components/header/logo";
import Detalhes from "@/features/Detalhes";
import StepAcordions from "@/components/acorddions/stepAcordions";
import Usuario from "@/features/Usuario";
import Pagamentos from "@/features/Pagamentos";
import Sucesso from "@/features/Sucesso";
import Rodape from "@/features/Rodape";
import { GET_USER_STEP, GET_USER_TAB } from "@/store/slices/appSlice";
import {useSelector} from "react-redux";
import PrecisaAjuda from "@/features/PrecisaAjuda";
import Chat from "@/features/Chat";
import Mensagem from "@/features/Mensagem";
import Modals from "@/components/modals";
import Endereco from "@/features/Endereco";
import { GET_USER } from "@/store/slices/userSlice";
import { GET_PAYMENT_DATA } from "@/store/slices/paymentSlice";

export default function Impresso() {
    const finishStep = 4;
    const current = useSelector(GET_USER_STEP)
    const USER_TAB = useSelector(GET_USER_TAB)
    const USER = useSelector(GET_USER)
    const payment = useSelector(GET_PAYMENT_DATA)
    const address = USER.address
    const typePayment = payment.forma === 'cc' ? 'Cartão de Crédito' : 'Débito em Conta'
    return (
        <>
            <Logo/>
            <Detalhes/>
            <StepAcordions title={'Identificação'} subtitle={USER.email} step={'1'} page='impresso'>
                <Usuario></Usuario>
            </StepAcordions>
            <StepAcordions title={'Entrega'} subtitle={`CEP - ${address?.cep}`} step={'2'}>
                <Endereco/>
            </StepAcordions>
            <StepAcordions title={'Pagamento'} subtitle={typePayment} step={'3'}>
                <Pagamentos></Pagamentos>
            </StepAcordions>
            {current === finishStep && <Sucesso />}
            <PrecisaAjuda />
            {USER_TAB === 3 && 
            <>
                <Chat />
                <Mensagem />
            </>            

            }
            <Rodape />
            <Modals />
        </>
    )
}
